import { z } from 'zod';
// --- Flag / experiment assignment response ---
export const flagAssignmentSchema = z
    .object({
    value: z.union([z.boolean(), z.string()]).meta({ description: 'Evaluated flag value' }),
    payload: z
        .record(z.string(), z.unknown())
        .meta({ description: 'Optional variant payload' })
        .optional(),
})
    .meta({ id: 'FlagAssignment' });
export const experimentAssignmentSchema = z
    .object({
    variant: z.string().meta({ description: 'Assigned variant ID', example: 'control' }),
    experiment_id: z.string().meta({ description: 'Experiment ID' }),
})
    .meta({ id: 'ExperimentAssignment' });
export const flagsResponseSchema = z
    .object({
    experiments: z
        .record(z.string(), experimentAssignmentSchema)
        .meta({ description: 'Experiment assignments keyed by experiment name' }),
    flags: z
        .record(z.string(), flagAssignmentSchema)
        .meta({ description: 'Flag evaluations keyed by flag ID' }),
})
    .meta({ id: 'FlagsResponse', description: 'Flag and experiment assignments for a visitor' });
// --- Event ingestion response ---
export const eventBatchResponseSchema = z
    .object({
    accepted: z
        .number()
        .int()
        .min(0)
        .meta({ description: 'Number of events successfully accepted' }),
    rejected: z
        .number()
        .int()
        .min(0)
        .meta({ description: 'Number of events rejected due to validation errors' }),
    duplicate: z.number().int().min(0).optional().meta({
        description: 'Number of events deduplicated by server (same event_id seen within 5 minutes). Absent when zero.',
    }),
    errors: z
        .array(z
        .object({
        index: z.number().int().min(0),
        message: z.string(),
    })
        .meta({ description: 'Index and message for each rejected event' }))
        .optional(),
})
    .meta({ id: 'EventBatchResponse', description: 'Result of event batch ingestion' });
//# sourceMappingURL=api-responses.js.map